import type React from 'react';
import { useState } from 'react';

const hasFiles = (event: React.DragEvent) => event.dataTransfer.types.includes('Files');

/** Drag-over/drop/keyboard-activation handlers for the video library upload dropzone. */
export function useMediaUploadZoneDrag(uploading: boolean, addFiles: (files: File[]) => void) {
  const [over, setOver] = useState(false);

  const onKeyDown = (event: React.KeyboardEvent, openPicker: () => void) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openPicker();
    }
  };

  const onDragOver = (event: React.DragEvent) => {
    if (!hasFiles(event)) return;
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
    setOver(true);
  };

  const onDragLeave = (event: React.DragEvent) => {
    if (!event.currentTarget.contains(event.relatedTarget as Node | null)) setOver(false);
  };

  const onDrop = (event: React.DragEvent) => {
    if (!hasFiles(event)) return;
    event.preventDefault();
    setOver(false);
    if (!uploading) addFiles(Array.from(event.dataTransfer.files));
  };

  return { over, onKeyDown, onDragOver, onDragLeave, onDrop };
}
